import { render, staticRenderFns } from "./travelers.vue?vue&type=template&id=8cb8f5ea"
import script from "./travelers.vue?vue&type=script&lang=js"
export * from "./travelers.vue?vue&type=script&lang=js"
import style0 from "./travelers.vue?vue&type=style&index=0&id=8cb8f5ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports